import FieldType from '../../components/Form/Fields/type'
import { lengthRequired } from '@polvo-labs/form-utils'
import Password from '../../components/Form/Fields/Password'

export interface ValidatePasswordFormData {
  password: string
}

export type ValidatePasswordForm = keyof ValidatePasswordFormData

const fields: FieldType<ValidatePasswordForm>[] = [
  {
    name: 'password',
    component: Password,
    data: {
      icon: 'password',
      label: 'Digite a sua senha para prosseguir',
    },
    html: {
      placeholder: 'Digite sua senha',
    },
    validation: lengthRequired({ min: 0, max: 255 }),
  },
]

export default fields
